<style scoped lang="stylus" rel="stylesheet/stylus">
.calendar {
  width 100%
  height 100%
  overflow-y scroll
  // font-size 14px
  color #323233
  background rgb(242, 243, 245)

  .header {
    display flex
    color rgb(51, 51, 51)
    background rgb(247, 247, 247)
    box-shadow 0 2px 6px rgba(0, 0, 0, 0.06)
    padding 16px 14px 20px 16px
    .title {
      font-size 26px
      line-height 34px
    }
    .time {
      font-size 14px
      line-height 22px
      color rgb(102, 102, 102)
      padding 12px 15px 0
      .arrow {
        font-size 16px
      }
    }
    .address {
      flex 1
      justify-content flex-end
      padding 12px 0 0
      .location {
        margin 2px 8px 0 0
      }
    }
  }

  .weeks {
    flex-wrap wrap
    background rgb(255, 255, 255)
    padding 15px 9px 11px
    margin-top 14px
    div {
      width 45px
      height 22px
      font-size 13px
      text-align left
      line-height 22px
      color rgb(153, 153, 153)
      padding-left 9px
      margin 0 3px
    }
  }

  .months {
    position: relative;
    width: 100%;
    height: 427px;
    background rgb(255, 255, 255)
    overflow: hidden;

    .month {
      position absolute
      width 100%
      flex-wrap wrap
      padding 0 9px
      .day {
        display flex
        align-items flex-start
        flex-wrap wrap
        position relative
        box-sizing border-box
        width 45px
        height 62px
        text-align left
        color rgb(153, 153, 153)
        background #F7F8FA
        border-radius 4px
        padding 6px 4px
        margin 0 3px 7px
        &.currMonthDay {
          color rgb(255, 255, 255)
          text-shadow: 0 1px 0 rgba(0, 0, 0, 0.15)
        }
        &.currDay {
          width 47px
          height 63px
          border 1px solid #FFFFFF
          border-top none
          box-shadow 3px 3px 0 rgba(216, 217, 217, 0.5)
          margin 0 2px 6px
        }
        &.forecast .aqi-value {
          font-size 20px
          line-height 10px
          padding 0
          margin-top -8px
          transform-origin left
          transform scale(0.5)
        }
      }

      .date {
        width 100%
        font-size 20px
        height 10px
        line-height 5px
        padding-left 6px
        transform-origin left
        transform scale(0.5)
      }
      .primary-pollution {
        width 100%
        font-size 20px
        height 10px
        line-height 1px
        font-weight bold
        padding-left 6px
        margin-top -3px
        transform-origin left
        transform scale(0.5)
      }
      .aqi-value {
        width 100%
        align-self flex-end
        font-size 15px
        line-height 15px
        white-space nowrap
        padding-left 3px
        margin-top -8px
      }
    }
  }

  .calendar-legend {
    padding 0 12px
    margin 6px 0 32px
  }

  .pollute-days {
    color rgb(51, 51, 51)
    background rgb(255, 255, 255)
    padding 9px 14px 17px
    margin-top 14px
    .title {
      font-size 14px
      font-weight bold
      text-align left
      line-height 22px
      border-bottom 1px solid #F1F1F1
      padding-bottom 9px
    }
    .bottom {
      display grid
      grid-template-columns max-content auto max-content
      justify-items center
      .item {
        display flex
        align-items center
        width 77px
        font-size 12px
        line-height 17px
        margin-top 17px
        .levelValue {
          width 4px
          height 10px
          border-radius 32px
          margin-right 6px
        }
        .levelText {
          flex 1
          text-align left
        }
        .day-num {
          color rgb(102, 102, 102)
        }
      }
    }
  }

  .source {
    margin 14px 0 40px
    .source-item {
      text-align center
      font-size 10px
      line-height 14px
      color rgb(153, 153, 153)
      margin-bottom 4px
    }
  }
}
</style>

<template>
	<div class="calendar" @touchstart.stop @touchmove.stop @touchend.stop>
		<div class="header">
			<div class="title">{{ hanziMonth }}月</div>
			<div class="time flex-row-cen-cen" @click="test">
				{{ tYear }}年
				<span class="arrow adv-chevron-right"></span>
			</div>
			<div class="address flex-row-cen-cen">
				<span class="location adv-location"></span>
				<!-- {{cityName}} -->
				xxx城市
				<!--<span class="arrow adv-chevron-right"></span>-->
			</div>
		</div>

		<div class="weeks flex-row-sta-cen">
			<div>日</div>
			<div>一</div>
			<div>二</div>
			<div>三</div>
			<div>四</div>
			<div>五</div>
			<div>六</div>
		</div>

		<div class="months" v-finger:swipe="swipeHandler">
			<div
				v-for="month of months"
				:key="month.id"
				class="month flex-row-sta-cen"
				:style="{
					left: 'calc(' + month.position * 100 + '% + ' + moveX + 'px)',
					transition: moveX ? '0.1s' : '0.8s'
				}"
			>
				<!--天格子-->
				<div
					v-for="(day, index) of month.days"
					:key="index"
					class="day"
					:class="{
						currMonthDay: day.isCurrMonth,
						currDay: day.isNowDate,
						forecast: day.aqiVal.toString().includes('-') && day.aqiVal !== '--'
					}"
					:style="{
						background: day.isCurrMonth ? getDayBackground(day) : 'rgb(245, 245, 245)',
						'box-shadow': currDayShadow(day)
					}"
				>
					<!--内部改内容和样式-->
					<div class="date">{{ day.text }}</div>
					<div v-for="(pollution, index) of day.primaryPollution" :key="index" class="primary-pollution">
						{{ pollution }}
					</div>
					<div class="aqi-value">{{ day.aqiVal }}</div>
				</div>
			</div>
		</div>

		<!--下面优良天数的统计-->
		<div class="pollute-days">
			<div class="title">污染天数统计</div>
			<div class="bottom">
				<div v-for="(item, index) in levelData" :key="index" class="item">
					<div :style="{ background: item.background }" class="levelValue"></div>
					<div class="levelText">{{ item.text }}</div>
					<div class="day-num">{{ item.value }}天</div>
				</div>
			</div>
		</div>

		<div class="source" @click="testvalue">
			<div class="source-item">单位：除AQI无量纲，CO为mg/m³，其余参数单位均为ug/m³</div>
			<div class="source-item">数据来源：中国环境监测总站</div>
		</div>

		<home-btn></home-btn>

		<van-popup v-model="show" position="bottom">
			<van-datetime-picker
				v-model="currentDate"
				type="year-month"
				:min-date="minDate"
				:max-date="maxDate"
				:formatter="formatter"
				@change="monthChange"
				@confirm="submit"
				@cancel="cancel"
			/>
		</van-popup>
		<tab-bar />
	</div>
</template>

<script>
import tabBar from '../../components/navigation/tab-bar'
// import { locationMixin } from '../../utils/mixins'
// import Legend from '../../components/Legend.vue'
import homeBtn from '../../components/navigation/home-btn'
export default {
	name: 'calendar',
	// mixins: [locationMixin],
	components: {
		tabBar,
		// Legend,
		homeBtn
	},
	computed: {
		hanziMonth: function() {
			const haziData = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二']
			return haziData[this.tMonth - 1]
		},
		currDayShadow() {
			return day => {
				if (!day.isNowDate) return ''
				if (!day.isCurrMonth) return '3px 3px 0 rgba(245, 245, 245, 0.5)'
				if (!day.aqiVal === '--') return '3px 3px 0 rgba(216, 217, 217, 0.5)'
				let aqi
				if (typeof day.aqiVal === 'number') {
					aqi = day.aqiVal
				} else if (day.aqiVal.includes('-')) {
					aqi = day.aqiVal.split('-')[1]
				}
				const color = this.$common.aqiShadowArr[this.$common.getAqiLevel(aqi)]
				return '3px 3px 0 ' + color.replace('0.35', '0.5')
			}
		}
	},
	watch: {
		currentDate(val) {
			console.log(val)
		}
	},
	data() {
		return {
			fullTime: '',
			copyMonth: '',
			copyYear: '',
			tMonth: '',
			tYear: '',
			tDate: '',
			calendarMonth: '',
			show: false,
			minDate: new Date(2019, 0, 1),
			maxDate: new Date(2025, 10, 1),
			currentDate: new Date(),
			levelData: [
				{ text: '优', background: '', value: '0' },
				{ text: '良', background: '', value: '0' },
				{ text: '轻度', background: '', value: '0' },
				{ text: '中度', background: '', value: '0' },
				{ text: '重度', background: '', value: '0' },
				{ text: '严重', background: '', value: '0' }
			],
			months: [
				// {
				//   id: new Date().getTime(),
				//   days: [{ text: 1, isCurrMonth: false }],
				//   position: -1
				// }
			],
			dataSource: '', // 接口参数
			currMonthText: '',
			countText: '',
			countTextArr: ['优级天数', '良级天数', '轻度污染天数', '中度污染天数', '重度污染天数', '严重污染天数'],
			pollutionCount: [],
			startX: null,
			moveX: 0,
			minMoveX: 20,
			cancelTokenId: null
		}
	},
	methods: {
		onLocation() {
			this.getcalendarData()
		},
		cancel() {
			this.show = false
		},
		submit() {
			this.show = false
			this.tMonth = parseInt(this.copyMonth)
			this.tYear = this.copyYear
			const data = `${this.tYear}-${this.copyMonth}`
			// 初始化日历
			this.initCalendar(data)
			this.getcalendarData()
		},
		monthChange(e) {
			const b = e.getValues().join('-')
			console.log(e.getValues())
			this.copyYear = b.substring(0, 4)
			const c = b.substring(b.length - 3)
			// console.log(this.tYear,c)
			this.copyMonth = c.substring(0, 2)
		},
		testvalue() {
			console.log(this.months)
		},
		formatter(type, val) {
			if (type === 'year') {
				return `${val}年`
			} else if (type === 'month') {
				return `${val}月`
			}
			return val
		},
		test() {
			this.show = true
		},
		// 关闭
		closePanel() {
			this.$emit('close')
		},
		swipeHandler(e) {
			const dir = e.direction
			if (dir === 'Left') {
				this.nextMonth()
			} else if (dir === 'Right') {
				this.prevMonth()
			}
		},
		touchstart(e) {
			console.log(e)
			this.startX = e.changedTouches[0].pageX
		},
		touchmove(e) {
			const nowX = e.changedTouches[0].pageX
			const diffX = nowX - this.startX
			if (Math.abs(diffX) <= this.minMoveX) return
			this.moveX = diffX
		},
		touchend(e) {
			const endX = e.changedTouches[0].pageX
			const diffX = endX - this.startX
			if (Math.abs(diffX) <= this.minMoveX) {
				this.moveX = 0
			} else {
				if (diffX < 0) this.nextMonth()
				if (diffX > 0) this.prevMonth()
			}
		},
		// 设置显示时间
		setMonthText(currMonth) {
			const time = currMonth.split('/')
			this.currMonthText = `${time[0]}年${time[1]}月`
		},
		// 切换至上一个月
		prevMonth() {
			const currMonth = this.months[0].monthStr
			// ++更新后的日期
			const b = currMonth.substring(currMonth.length - 2)
			this.tMonth = parseInt(b)
			this.tYear = currMonth.substring(0, 4)
			// ++
			const prevMonth = this.$common.getPrevMonth(currMonth, '/')
			const prevMonthDays = this.getMonthDays(new Date(prevMonth + '/01'))
			// this.initCalendar(currMonth);
			this.moveX = 0
			for (const month of this.months) {
				month.position++
			}
			this.months.splice(0, 0)
			this.months.unshift({
				id: new Date().getTime(),
				days: prevMonthDays,
				position: -1,
				monthStr: prevMonth
			})
			this.setMonthText(currMonth)
			setTimeout(() => {
				this.months.pop()
				this.getcalendarData()
			}, 1)
		},
		// 切换至下一个月
		nextMonth() {
			const currMonth = this.months[2].monthStr
			// ++更新后的日期
			const b = currMonth.substring(currMonth.length - 2)
			this.tMonth = parseInt(b)
			this.tYear = currMonth.substring(0, 4)
			// ++
			const nextMonth = this.$common.getNextMonth(currMonth, '/')
			const nextMonthDays = this.getMonthDays(new Date(nextMonth + '/01'))
			// this.initCalendar(currMonth);
			this.moveX = 0
			for (const month of this.months) {
				month.position--
			}
			this.months.splice(0, 0)
			this.months.push({
				id: new Date().getTime(),
				days: nextMonthDays,
				position: 1,
				monthStr: nextMonth
			})
			this.setMonthText(currMonth)
			setTimeout(() => {
				this.months.shift()
				this.getcalendarData()
			}, 1)
		},

		// 获取指定月所有天数
		getMonthDays(date) {
			if (!(date instanceof Date)) {
				date = new Date(date)
			}
			if (date.toString() === 'Invalid Date') return []

			const today = new Date()
			const todayYear = today.getFullYear()
			const todayMonth = today.getMonth()
			const todayDate = today.getDate()

			const year = date.getFullYear()
			const month = date.getMonth()
			const monthDayCount = new Date(year, month + 1, 0).getDate()
			const preMonthLastDate = new Date(year, month, 0)
			const preMonthDayCount = preMonthLastDate.getDate()
			const preMonthLastDateWeek = preMonthLastDate.getDay()
			const nexMonthLastDate = new Date(year, month + 2, 0)

			const days = []

			if (preMonthLastDateWeek < 6) {
				const isSameTodayMonth = compareTodayMonth(preMonthLastDate)
				for (let i = preMonthLastDateWeek; i >= 0; i--) {
					const dayDate = preMonthDayCount - i
					days.push({
						text: dayDate,
						isCurrMonth: false,
						isNowDate: isSameTodayMonth && dayDate === todayDate,
						aqiVal: '',
						background: 'rgb(245,245,245)',
						color: 'rgb(245,245,245)'
					})
				}
			}

			let isSameTodayMonth = compareTodayMonth(date)
			for (let i = 1; i <= monthDayCount; i++) {
				const dayDate = i
				days.push({
					text: dayDate,
					isCurrMonth: true,
					isNowDate: isSameTodayMonth && dayDate === todayDate,
					aqiVal: '',
					background: 'rgb(245,245,245)',
					color: 'rgb(245,245,245)'
				})
			}

			isSameTodayMonth = compareTodayMonth(nexMonthLastDate)
			for (let i = 1; days.length < 42; i++) {
				const dayDate = i
				days.push({
					text: dayDate,
					isCurrMonth: false,
					isNowDate: isSameTodayMonth && dayDate === todayDate,
					aqiVal: '',
					background: 'rgb(245,245,245)',
					color: 'rgb(245,245,245)'
				})
			}

			return days

			function compareTodayMonth(date) {
				const dateYear = date.getFullYear()
				const dateMonth = date.getMonth()
				return dateYear === todayYear && dateMonth === todayMonth
			}
		},

		// 处理当前月份接口数据
		proCurrMonthData(monthData) {
			let i = 0
			for (const day of this.months[1].days) {
				// console.log(day)
				if (day.isCurrMonth) {
					const dayData = monthData[i] || {}
					day.aqiVal = dayData.value || '--'
					day.background = dayData.color
					day.primaryPollution = dayData.primaryPollution || '--'
					day.primaryPollution = day.primaryPollution.split(',')
					i++
				} else {
					day.aqiVal = '--'
					day.primaryPollution = ['--']
					day.background = 'rgb(245,245,245)'
					day.color = 'rgb(245,245,245)'
				}
			}
			// console.log(this.months[1].days)
		},
		// 处理统计描述文字
		proCountText(counts = []) {
			let i = 0
			let text = ''
			for (const count of counts) {
				if (count > 0) {
					text += `${this.countTextArr[i]}${count}天，`
				}
				i++
			}
			if (text) {
				text = '月' + text
				text = text.replace(/(.*)，/, '$1。')
			}
			this.countText = text
		},
		// 获取数据类型
		// async getDataSource() {
		// 	const data = {
		// 		code: 'defaultCityDataType'
		// 	}
		// 	const res = await this.$http.getCityDataSource(data)
		// 	if (res.status === 0 && res.data) {
		// 		this.dataSource = res.data.value
		// 	}
		// },
		// 初始日历(页面初始化时 和 选择时间后 调用这个接口)
		initCalendar(currMonth) {
			currMonth = currMonth.replace(/\-/g, '/')
			const currMonthDays = this.getMonthDays(new Date(currMonth + '/01'))
			const prevMonth = this.$common.getPrevMonth(currMonth, '/')
			const prevMonthDays = this.getMonthDays(new Date(prevMonth + '/01'))
			const nextMonth = this.$common.getNextMonth(currMonth, '/')
			const nextMonthDays = this.getMonthDays(new Date(nextMonth + '/01'))
			this.months = [
				{
					id: new Date().getTime() * 10 + 1,
					days: prevMonthDays,
					position: -1,
					monthStr: prevMonth
				},
				{
					id: new Date().getTime() * 10 + 2,
					days: currMonthDays,
					position: 0,
					monthStr: currMonth
				},
				{
					id: new Date().getTime() * 10 + 3,
					days: nextMonthDays,
					position: 1,
					monthStr: nextMonth
				}
			]
			this.setMonthText(currMonth)
			// this.getcalendarData()
		},
		async getcalendarData() {
			this.$cancelAxios(this.cancelTokenId)
			const params = {
				cityCode: this.cityCode,
				year: this.tYear,
				month: this.tMonth
			}
			const res = await this.$http.getAirCalendar(params)
			if (res.status === 0 && res.data) {
				const monthData = res.data.datas
				const counts = res.data.count
				this.proCurrMonthData(monthData)
				this.proCountText(counts)
				this.pollutionCount = counts || []
				this.levelData.map((item, index) => {
					// console.log(counts[index])
					this.$set(item, 'value', counts[index])
					this.$set(item, 'background', this.$common.aqiColorArr[index])
					// console.log(item)
				})
			} else {
				this.proCountText([])
				this.pollutionCount = []
			}
		},
		getDayBackground(day) {
			let bgColor = ''
			if (day.aqiVal.toString().includes('-') && day.aqiVal !== '--') {
				bgColor = `linear-gradient(90deg, ${
					this.$common.aqiColorArr[this.$common.getAqiLevel(day.aqiVal.split('-')[0])]
				} 0%, ${this.$common.aqiColorArr[this.$common.getAqiLevel(day.aqiVal.split('-')[1])]} 100%)`
			} else {
				bgColor = this.$common.aqiColorArr[this.$common.getAqiLevel(day.aqiVal)]
			}
			return bgColor
		}
	},
	mounted() {
		const date = new Date()
		const year = date.getFullYear()
		this.tYear = date.getFullYear()
		let month = date.getMonth() + 1
		this.tMonth = date.getMonth() + 1
		this.tDate = date.getDate()
		if (month < 10) {
			month = `0${month}`
		}
		this.copyYear = year
		this.copyMonth = month
		this.fullTime = `${year}-${month}`
		this.initCalendar(this.fullTime)
	}
}
</script>
